import AbonoService from "@/services/cxp/AbonoService";
import TipoAbonoService from "@/services/cxp/TipoAbonoService";
import AbonoSerieService from "@/services/cxp/AbonoSerieService";

const fetch = (context, params) => {
  return AbonoService.fetch(params)
    .then(res => {
      context.commit('ABONOS', res.data);
    });
};

const abonoserie = (context, params) => {
  return AbonoSerieService.fetch(params)
    .then(res => {
      context.commit('ABONOSERIE', res.data);
    });
};


const abonos = (context, params) => {
  return AbonoService.fetch(params)
    .then(res => {
      context.commit('ABONOS', res.data);
    });
};


const tipoabono = (context, params) => {
  return TipoAbonoService.fetch(params)
    .then(res => {
      context.commit('TIPOABONO', res.data);
    });
};

export default {
  fetch,
  tipoabono,
  abonos,
  abonoserie,
};